module.exports = __webpack_public_path__ + "img/pattern1 blue copy 6.5d3c5581.svg";